import React from "react";
import Item from "../../../components/print/workDiary/Item";
import { Typography } from "antd";
import { useIntl } from "react-intl";
import { getFullName } from "../../../components/util/helpers";
const { Title } = Typography;

const CaregiverApproval = (props) => {
  const intl = useIntl();
  const { employee } = props;
  const fullName = employee
    ? getFullName(employee.surename, employee.first_name)
    : "לא קיים";
  const truncate = (input, num) =>
    input.length > num ? `${input.substring(0, num)}...` : input;
  return (
    <div className="borderedSection" style={{ width: "100%" }}>
      <Title level={5}>
        {intl.formatMessage({
          id: "app.work_diary_print.caregiver_approval",
        })}
      </Title>

      <div className="rowContainer">
        <div style={{ flex: 2, display: "flex" }}>
          <Item
            name="name"
            content={truncate(fullName, 18)}
            line_type="vertical"
          />
        </div>
        <div style={{ flex: 1, display: "flex", margin: "0 10px" }}>
          <Item name="signature" line_type="vertical" />
        </div>

        <div style={{ flex: 1, display: "flex" }}>
          <Item name="date" line_type="vertical" />
        </div>
      </div>
    </div>
  );
};

export default CaregiverApproval;
